export default {"src":"/_next/static/media/lounge.b7d363a1.svg","height":30,"width":29,"blurWidth":0,"blurHeight":0};